import React, {useState} from "react";
import {
    Create,
    FormTab,
    TextInput,
    TabbedForm,
    Toolbar,
    ReferenceInput,
    NumberInput
} from 'react-admin';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from "@material-ui/core";
import SaveIcon from '@material-ui/icons/Save';
import ComboUnidadNegocio from "../componentes/ComboUnidadNegocio";


const useStyles = makeStyles((theme) => ({
    sector: {display: 'inline-block', width: 200, marginLeft: 8},
    sector_d: {display: 'inline-block', width: 400, marginLeft: 8},
}));

const PostCreateToolbar = props => {
    return (
        <Toolbar {...props} >

        </Toolbar>
    )

};

const validateCreate = (values) => {
    const errors = {};

    var w_sector = values.sector

    if (w_sector===undefined) {
        errors.sector = ['El campo Código es requerido'];
    }else {
        if (w_sector === null) {
            errors.sector = ['El campo Código es requerido'];
        } else {
            w_sector = w_sector.trim()
            if (w_sector === '') {
                errors.sector = ['El campo Código es requerido'];
            }
        }
    }


    var w_sector_d = values.sector_d

    if (w_sector_d===undefined) {
        errors.sector_d = ['El campo Descripcion es requerido'];
    }else {
        if (w_sector_d === null) {
            errors.sector_d = ['El campo Descripcion es requerido'];
        } else {
            w_sector_d = w_sector_d.trim()
            if (w_sector_d === '') {
                errors.sector_d = ['El campo Descripcion es requerido'];
            }
        }
    }


    return errors
};

// redirect to the related Author show page
const redirect = (basePath, id, data) => `/UnidadSector`;

const UnidadSectorCreate = props => {
    const classes = useStyles();

    const PostTitle = ({record}) => {
        return <span>Alta de Unidad Sector</span>;
    };

    return (
        <Create title={<PostTitle/>} {...props}>
            <TabbedForm
                // toolbar={<PostCreateToolbar />} validate={validateCreate} redirect={redirect}
            >
                {/*Datos*/}
                <FormTab label="DATOS UNIDAD SECTOR">

                    <ComboUnidadNegocio readOnly={false}/>

                    <TextInput
                        label="Código Unidad Sector"
                        source="sector"
                        formClassName={classes.sector}
                        placeholder="Ingrese Código Unidad Sector"
                        helperText="Código"
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                    />

                    <br/>

                    <TextInput
                        id="standard-full-width"
                        label="Descripción Unidad Sector"
                        source="sector_d"
                        formClassName={classes.sector_d}
                        multiline
                        placeholder="Ingrese Descripcion Unidad Sector"
                        helperText="Descripcion"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                    />
                    <br/>

                </FormTab>
            </TabbedForm>
        </Create>
    )
};
export default UnidadSectorCreate;


